import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Themed } from 'theme-ui';
import { Button } from '../../elements/trustyle-button';
import DropDown from '../../elements/drop-down';
import { GridLayout } from '@uswitch/ev-core/react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var Column = GridLayout.Column;

var DropdownFilter = function DropdownFilter(_ref) {
  var filter = _ref.filter,
      setOptionValue = _ref.setOptionValue;
  return _jsxs(Column, {
    s: 1 / 1,
    m: 4 / 12,
    l: 4 / 12,
    sx: {
      padding: 0
    },
    children: [_jsx("label", {
      for: filter.label,
      children: filter.label
    }), _jsx(DropDown, {
      name: filter.label,
      onBlur: function onBlur() {},
      onChange: function onChange(o) {
        var option = JSON.parse(o);
        setOptionValue(filter, option, option.value);
      },
      options: filter.options.map(function (option) {
        return {
          text: option.label,
          value: JSON.stringify(option)
        };
      }),
      value: JSON.stringify(filter.options.find(function (op) {
        return op.value;
      })),
      sx: {
        borderColor: 'grey-20',
        fontSize: 'xs'
      }
    })]
  }, filter.label);
};

var CheckboxFilter = function CheckboxFilter(_ref2) {
  var filter = _ref2.filter,
      setOptionValue = _ref2.setOptionValue;
  return _jsxs("div", {
    children: [filter.label, filter.options.map(function (option, index) {
      return _jsxs("label", {
        sx: {
          display: 'block',
          marginY: 'xs'
        },
        children: [_jsx("input", {
          type: "checkbox",
          defaultChecked: option.value,
          onChange: function onChange(e) {
            return setOptionValue(filter, option, e.target.checked);
          },
          sx: {
            marginRight: 'xs'
          }
        }), option.label]
      }, option.label);
    }, this)]
  }, filter.label);
};

var Filter = function Filter(_ref3) {
  var filterBy = _ref3.filterBy,
      setFilterBy = _ref3.setFilterBy,
      handleFilterClick = _ref3.handleFilterClick,
      setFilterOpen = _ref3.setFilterOpen;

  var setOptionValue = function setOptionValue(filter, option, value) {
    var optionIndex = filter.options.indexOf(option);
    var checkboxOptions = [].concat(_toConsumableArray(filter.options.slice(0, optionIndex)), [{
      label: option.label,
      value: value
    }], _toConsumableArray(filter.options.slice(optionIndex + 1)));
    var dropdownOptions = filter.options.map(function (op) {
      return _objectSpread(_objectSpread({}, op), {}, {
        value: op.label === option.label
      });
    });
    var newFilter = {
      label: filter.label,
      type: filter.type,
      options: filter.type === 'dropdown' ? dropdownOptions : checkboxOptions
    };
    var filterIndex = filterBy.indexOf(filter);
    var newFilterBy = [].concat(_toConsumableArray(filterBy.slice(0, filterIndex)), [newFilter], _toConsumableArray(filterBy.slice(filterIndex + 1)));
    setFilterBy(newFilterBy);
  };

  return _jsxs("div", {
    sx: {
      marginY: 0,
      padding: 'md',
      backgroundColor: 'grey-05',
      borderRadius: 3
    },
    children: [filterBy.map(function (filter, index) {
      return [filter.type === 'dropdown' ? _jsx(DropdownFilter, {
        filter: filter,
        setOptionValue: setOptionValue
      }, "0") : _jsx(CheckboxFilter, {
        filter: filter,
        setOptionValue: setOptionValue
      }, "0"), _jsx(Themed.hr, {}, "1")];
    }, this), _jsxs("div", {
      sx: {
        textAlign: 'right'
      },
      children: [_jsx(Button, {
        variant: "secondary",
        onClick: function onClick() {
          return setFilterOpen(false);
        },
        children: "Close"
      }), _jsx(Button, {
        variant: "primary",
        sx: {
          marginLeft: 'sm'
        },
        onClick: handleFilterClick,
        children: "Update results"
      })]
    })]
  });
};

export default Filter;
//# sourceMappingURL=filters.js.map